// https://billauer.se/blog/2021/12/quill-br-shift-enter/

import { Quill } from 'vue2-editor';

const Parchment = Quill.import('parchment');
const Delta = Quill.import('delta');

class ShiftEnterBlot extends Parchment.Embed {
  static create() {
    const el = document.createElement('br');
    el.className = 'soft-break';
    return el;
  }
  static value() { return true; }
}
ShiftEnterBlot.blotName = 'ShiftEnter';
ShiftEnterBlot.tagName = 'br';
ShiftEnterBlot.className = 'soft-break';
Quill.register(ShiftEnterBlot);

export function installSoftBreak(quillInstance, onClean) {
  quillInstance.keyboard.bindings[13].unshift({
    key: 13,
    shiftKey: true,
    handler: function(range) {
      quillInstance.updateContents(
        new Delta().retain(range.index).delete(range.length).insert({ ShiftEnter: true }),
        'user'
      );

      if (!quillInstance.getLeaf(range.index + 1)[0].next) {
        quillInstance.updateContents(
          new Delta().retain(range.index + 1).delete(0).insert({ ShiftEnter: true }),
          'user'
        );
      }

      quillInstance.setSelection(range.index + 1, Quill.sources.SILENT);
      return false;
    }
  });

  quillInstance.root.addEventListener('blur', () => {
    if (onClean) onClean(quillInstance.root.innerHTML.replace(/(<br class="soft-break">)+(<\/p>)/gi, '$2'));
  });
}
